import { render } from "./IssueSeverityText.vue?vue&type=template&id=2ff0b702&scoped=true"
import script from "./IssueSeverityText.vue?vue&type=script&lang=js"
export * from "./IssueSeverityText.vue?vue&type=script&lang=js"

import "./IssueSeverityText.vue?vue&type=style&index=0&id=2ff0b702&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff0b702"]])

export default __exports__